





















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { ActionError as userStoreErr } from '@/store/user/types';
import Logo from '@/assets/img/logo.svg';

import { UserState } from '@/store/user/types';

import { logout } from '@/const/terms/feedback/user';

@Component<Header>({
    name: 'Header',
})
export default class Header extends Vue {
    private logo: string = Logo;
    private logoutConfirmVisible: boolean = false;

    // vuex
    @Action('User/LOGOUT') private logout: any;
    @State('User') private user!: UserState;

    // methods
    public async logoutHandler() {
        this.logoutConfirmVisible = false;
        try {
            await this.logout();
            this.$notify.success({ message: logout.success.message, title: logout.success.title});
            this.$router.push({name: 'login'});
        } catch (err) {
            switch (err.type) {
                case userStoreErr.VUEX_CLEAR_USER:
                    this.$notify.error({ message: logout.error.fail, title: logout.error.title });
            }
            throw err;
        }
    }
}
